// export default {
const mixinDown = {
  data() {
    return {
      type: this.$route.params.type || 1, // 1 爱好者 2 卖家
      photoCategory: [], // 相册分类
      classifyId1: '',
      classifyTitle: '全部相册'
    };
  },
  methods: {
    toDown() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // alert('是否是Android：'+isAndroid);
      // alert('是否是iOS：'+isiOS);
      if (isAndroid && this.type == 1) {
        // 爱好者 安卓下载
        window.location.href = `https://play.google.com/store/apps/details?id=cn.kingsarts.jingyi`;
      } else if (isiOS && this.type == 1) {
        // 爱好者 ios 下载
        window.location.href = `https://itunes.apple.com/hk/app/經藝聯/id1524247193`;
      } else if (isAndroid && this.type == 2) {
        // 卖家 安卓下载
        window.location.href = `https://play.google.com/store/apps/details?id=cn.kingsarts.maijia`;
      } else if (isiOS && this.type == 2) {
        // alert(1)
        // 卖家 ios下载
        window.location.href = `https://itunes.apple.com/hk/app/經藝聯賣家/id1524254951`;
      }
    }
  },
};
export default mixinDown;
